module.exports = __webpack_public_path__ + "img/txt.dcd6e141.png";